import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'AceCore',
  brandName: 'AceCore',
  description: 'Sistema de agendamento para treinadores de ténis',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Quadra de ténis',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Treinador de ténis dando aula',
  },
  testimonials: [
    {
      name: 'Frederico Gil',
      role: 'Treinador de Ténis',
      text: 'O AceCore é a ferramenta que faltava para organizar as minhas aulas e a reserva de courts.',
      image: testimonial1,
    },
    {
      name: 'Catarina Lopes',
      role: 'Jogadora Amadora',
      text: 'Finalmente uma forma de marcar aulas que se adapta aos meus horários. Recomendo!',
      image: testimonial2,
    },
    {
      name: 'Clube de Ténis da Linha',
      role: 'Diretor Desportivo',
      text: 'A gestão dos treinadores e dos campos ficou muito mais simples e eficiente. Excelente plataforma.',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'treinador',
    professionals: 'treinadores',
    business: 'clube',
    businesses: 'clubes',
    service: 'aula',
    services: 'aulas',
    client: 'jogador',
    clients: 'jogadores',
    appointment: 'treino',
    appointments: 'treinos',
  },
  homepage: {
    hero: {
      badge: 'Ténis Profissional',
      title: 'Ace no seu negócio com AceCore',
      description: 'Otimize a gestão dos seus jogadores e maximize o potencial do seu ensino de ténis.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Courts integrados', 'Ranking de jogadores'],
    },
    statistics: [
      { value: '200+', label: 'Treinadores' },
      { value: '15k+', label: 'Aulas Agendadas' },
      { value: '96%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Reserva de Courts Complexa',
        description: 'Coordenar horários de aulas com disponibilidade de courts gera conflitos e desperdício.',
        icon: 'Calendar',
        quote: {
          text: 'Antes perdia 1 hora diária só organizando courts e horários. Agora é automático',
          author: 'Professor João Miguel',
          business: 'Academia de Ténis Porto',
        },
      },
      {
        title: 'Acompanhamento de Evolução',
        description: 'Sem registos adequados, é difícil acompanhar o progresso técnico de cada jogador.',
        icon: 'TrendingUp',
        stats: [
          { label: 'Jogadores sem acompanhamento:', value: '70%' },
          { label: 'Melhoria com registos:', value: '40% mais rápida' },
        ],
      },
      {
        title: 'Gestão de Grupos e Individuais',
        description: 'Misturar aulas individuais com grupos de diferentes níveis cria logística complexa.',
        icon: 'Users',
        quote: {
          text: 'Com AceCore consigo gerir 20 jogadores individuais e 5 grupos sem stress. Fantástico!',
          author: 'Instrutora Maria Antónia',
          business: 'Ténis Clube Cascais',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'AceCore: Match point para seu negócio',
      description: 'Tecnologia especializada que entende as necessidades únicas do ensino de ténis.',
      features: [
        {
          title: 'Gestão Integrada de Courts',
          description: 'Sincronização automática entre aulas e disponibilidade de quadras.',
        },
        {
          title: 'Perfis de Jogadores',
          description: 'Acompanhe nível, objetivos e progresso de cada jogador individualmente.',
        },
        {
          title: 'Planeamento de Torneios',
          description: 'Organize competições internas e gerencie inscrições facilmente.',
        },
      ],
    },
    testimonials: {
      title: 'Depoimentos dos treinadores',
      description: 'Profissionais do ténis que escolheram AceCore para elevar seu ensino.',
    },
    finalCta: {
      title: 'Pronto para dar um ace no seu negócio?',
      description: 'Junte-se aos treinadores que já revolucionaram seu ensino de ténis.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Ver Demonstração',
    },
    contact: {
      title: 'Contacte-nos',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de treinador',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
